<div
    class="linear-module-container__header"
    [ngClass]="{
        'linear-module-container__header--expandable': expandable,
        'linear-module-container__header--collapsed': expandable && !isExpanded(),
    }"
    (click)="toggleExpand($event)">
    @if (header) {
        <ng-container *ngTemplateOutlet="header.templateRef"></ng-container>
    }
    @if (expandable) {
        <span class="linear-module-container__header-chevron" [ngClass]="isExpanded() ? 'theme-up' : 'theme-down'"></span>
    }
</div>

@if (content && (isExpanded() || !expandable)) {
    <ng-container *ngTemplateOutlet="content.templateRef"></ng-container>
}
